import React, { useEffect, useRef } from 'react';
import './ReimagineSection.css';
import {Link} from 'react-router-dom';

const cards = [
  {
    id: 1,
    title: 'FINTECH',
    desc: 'Craft tailored financial applications for digital transformation with us, including web and mobile trading platforms, retail banking, investment solutions, and stock exchange apps.',
    bg: '/images/fintech.webp',
    link:'/portfolio/fintech'
  },
  {
    id: 2,
    title: 'HEALTHCARE',
    desc: 'Different devices used in healthtechBy embracing digital transformation in your healthcare practice, youre not only catering to the changing preferences of your existing patients but also positioning yourself to attract new ones.',
    bg: '/images/healthcare.webp',
     link: '/portfolio/healthcare',
  },
  {
    id: 3,
    title: 'TECHNOLOGY',
    desc: 'Whether its developing SaaS platforms or optimizing customer satisfaction, create tech solutions that not only set you apart but are also pivotal for your digital transformation journey.',
    bg: '/images/technology.avif',
    link: '/industries',
  },
];

const ReimagineSection = () => {
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    refs.current.forEach(ref => ref && observer.observe(ref));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="reimagine-section6511">
      <div className="container">
      <div className="reimagine-header6511">
        <h2 className="fade-left6511" ref={el => refs.current[0] = el}>
          WE HELP <span className="blue">REIMAGINE INDUSTRIES</span>
        </h2>
        <p className="fade-right6511" ref={el => refs.current[1] = el}>
          Explore how we partner with businesses across domains to create next-gen digital experiences that lead change.
        </p>
      </div>

      <div className="reimagine-cards6511">
        {cards.map((card, i) => (
          <div
            className="reimagine-card6511 fade-up6511"
            key={card.id}
            ref={el => refs.current[i + 2] = el}
            style={{ backgroundImage: `url(${card.bg})` }}
          >
            <div className="card-overlay6511">
              <h3 className="card-title6511">{card.title}</h3>
              <div className="card-hover-content6511">
  <p>{card.desc}</p>
  <Link to={card.link} className="explore-link">
    <span className="explore-arrow">→ EXPLORE</span>
  </Link>
</div>

            </div>
          </div>
        ))}
      </div>

      <div className="reimagine-btn">
        <Link to="/industries">
        <button>SEE ALL INDUSTRIES</button>
        </Link>
      </div>
      </div>
    </section>
  );
};

export default ReimagineSection;
